import { useAppMediaProvider } from '../../../baseStyles/AppMediaProvider';
import { usePrintableWorksheetsState } from 'printableWorksheets/state'
import React, { useEffect, useState } from 'react'
import './styles.scss'
import ArrowSVG from './treeViewArrow.svg'
import TeacherArrowSVG from './teacherTreeViewArrow.svg'
import RightArrowSVG from './right-arrow.svg'
import Button, { ButtonTypes } from 'printableWorksheets/atoms/Button';
import { WorksheetsEnvironment } from 'printableWorksheets';
import PrintableWorksheetsEvents from 'printableWorksheets/events';


export interface ITreeItem {
  id: number;
  playable_count: number;
  link_name: string;
  section_title: string;
  title?: boolean;
  children: Array<ITreeItem>
}

export interface IMobileState {
  data: ITreeItem;
  item: ITreeItem;
}

const WorksheetTopicSelector = () => {
  const {isMobile} = useAppMediaProvider();
  const { treeData = {}, setActiveBreadcrumb, activeBreadcrumb, subjectCode, setShowHeader, worksheetsEnvironment, onboardingGrade, activeGrade } = usePrintableWorksheetsState();
  const [visibleNodes, setVisibleNodes] = useState(activeBreadcrumb.length > 0 ? activeBreadcrumb.map((crumb: any) => crumb?.id) : []);
  const [regenerateCrumbs, setRegenerateCrumbs] = useState(false);
  const [mobileList2, setMobileList2] = useState<IMobileState>(null);
  const [mobileList3, setMobileList3] = useState<IMobileState>(null);
  const [lastNode, setLastNode] = useState<IMobileState>(null);
  const [selectedSubjects, setSelectedSubjects] = useState(["math", "ela"]);

  useEffect(()=> {
      setVisibleNodes(activeBreadcrumb?.map(crumb=>crumb?.id));
  }, [activeBreadcrumb])

 useEffect(()=> {
    if (regenerateCrumbs) {
      setRegenerateCrumbs(false);
      getCrumbsFromNodeList();
    }

  }, [regenerateCrumbs])

  const getParentNode = (nodeId : string, itemType: any) =>  {
    let nodeToReturn;
    visibleNodes.find(node=> {
      let crumb = findItemById(node, treeData[itemType]);
      let parent = crumb?.children?.find((child: any)=> child?.id === nodeId);
      if (parent) { 
        nodeToReturn = crumb;
      }
    })
    return nodeToReturn
  }

  const getCrumbsFromNodeList = () => {
      let crumbs:any[]  = [];

      visibleNodes.forEach(item=> {
        let element  = findItemById(item, treeData[0])
        if (element) {
        crumbs.push(element);
        } else {
          let element  = findItemById(item, treeData[1])
          crumbs.push(element);
        }
      })
      setActiveBreadcrumb(crumbs)
    
  }

  const findItemById = (id: any, data: any): any => {
    // Check if the current level contains the desired ID
    if (data?.id === id) {
      return data; // Return the item if the ID matches
    }
  
    // Check if the current level has children
    if (data.children && data.children.length > 0) {
      // Iterate through the children and recursively search for the ID
      for (let i = 0; i < data.children.length; i++) {
        const foundItem = findItemById(id, data.children[i]);
        if (foundItem) {
          return foundItem; // Return the found item
        }
      }
    }
  
    // Item not found
    return null;
  }

  const topicClicked = (lastNode: any, itemType: any = null) => {
    arrowClicked(lastNode, itemType);
    setRegenerateCrumbs(true);
  }

  const arrowClicked = (lastNode: any, itemType: any = null) => {
    const props = {
      clickedOn: 'Topic Selector',
      grade: onboardingGrade,
      newTopicSelected: lastNode?.title,
      newGradeSelected: '',
    };
    PrintableWorksheetsEvents.interactedPrintablesFilters(props);
    const subOfFirstBreadcrumb = getSubjectCodeOfFirstBreadcrumb();
    if(itemType != null && (itemType != subOfFirstBreadcrumb || visibleNodes?.[0] !== activeBreadcrumb?.[0]?.id) && treeData?.[itemType]?.id !== visibleNodes[0]){
      visibleNodes[0] = treeData?.[itemType]?.id; 
      visibleNodes.length = 1;
    } 
    if (lastNode?.id === visibleNodes[visibleNodes.length - 1]) {
      // if user clicks on the same node which he just opened it should close.
      visibleNodes.length = visibleNodes.length - 1;
      setVisibleNodes([...visibleNodes]);
    } else {
      let parent: any = getParentNode(lastNode?.id, itemType);
      if (parent) {
        if (parent.children.find((child: any) => child?.id === lastNode?.id)) {
          // if user clicks on another child of same parent which was last opened
          if (parent.children.find((child: any) => child?.id === visibleNodes[visibleNodes.length - 1])) {
            visibleNodes.length = visibleNodes.length - 1;
            setVisibleNodes([...visibleNodes, lastNode?.id]);
          } else {
            let index = visibleNodes.findIndex(node => parent?.id == node);
            visibleNodes.length = index +1;
            setVisibleNodes([...visibleNodes, lastNode?.id]);
          }
        } else {
          // if user clicks on one of the child nodes of already opened parent (not the last parent)
          let index = visibleNodes.findIndex(node => parent?.id == node);
          visibleNodes.length = index + 1;
          setVisibleNodes([...visibleNodes, lastNode?.id]);
        }
      } else {
        setVisibleNodes([...visibleNodes,lastNode?.id]);
      }
    }

  }

  const renderArrow = (isSelected: boolean, isActive: boolean, item: ITreeItem, itemType: number): any => {
    if(isSelected){
      return (
        <div className={`opened-caret${isActive ? ' highlighted-caret' : ''}`} onClick={(e)=>{e.stopPropagation();arrowClicked(item, itemType)}}>
          {worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? <TeacherArrowSVG/> :<ArrowSVG />}
        </div>
      )
    } else {
      return (
        <div className="caret-icon-container"  onClick={(e)=>{e.stopPropagation();arrowClicked(item, itemType)}}>
          {worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? <TeacherArrowSVG/> : <ArrowSVG/>}
        </div>
      )
    }
  }

  const renderTopics = (data: ITreeItem, itemType: number, isRoot: boolean = false) => {
    return data?.children?.map((item: ITreeItem) => {
    const isActive = visibleNodes[visibleNodes.length -1] === item?.id;
    const isExpanded = visibleNodes.includes(item?.id);

    return (<div key={item?.id} className={`worksheet-topic-container${isRoot? " root-topic-container": ""}`}>
      <div onClick={()=>topicClicked(item, itemType)} className={`worksheet-topic-name${isActive ? ' selected' : ''}`}>
        <div className='worksheet-label'>
          {isRoot ? null  : isExpanded ? (<div className={`marker`}/>) : null}
          {item.title}
        </div>
        {item?.children?.length > 0 ? renderArrow(isExpanded, isActive, item, itemType) : null}
      </div>
      <div className='worksheet-topic-children'>
       {item?.children?.length > 0 && visibleNodes.includes(item?.id) ? renderTopics(item, itemType) : null}
      </div> 
    </div>)})
  }

  const toggleSelectedSubjects = (sub: string) => {
      if (selectedSubjects.includes(sub)) {
          setSelectedSubjects(selectedSubjects.filter(subject=> subject !== sub))
      } else {
          setSelectedSubjects([...selectedSubjects, sub]);
      }
  }
  const renderDesktopTopics = () => {
    const isMathSelected = selectedSubjects.includes("math")
    const isElaSelected = selectedSubjects.includes("ela")
    return (worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ?  renderTeacherDashboardTopics(true) :<>
      <div className='worksheet-subject-name' onClick={(e) => {e.stopPropagation(); setActiveBreadcrumb([treeData?.[1]])}}>
        <div className={`marker`} />
        MATH
        {<div onClick={(event) => {event.stopPropagation(); toggleSelectedSubjects("math")}} className={isMathSelected ? 'opened-caret highlighted-caret' : 'caret-icon-container'}><ArrowSVG /></div>}
      </div>
      {selectedSubjects.includes("math") ? renderTopics(treeData?.[1], 1) : null}
      <div className='worksheet-subject-name' onClick={(e) => { e.stopPropagation(); setActiveBreadcrumb([treeData?.[0]])}}>
        <div className={`marker`} />
        ELA
        {<div onClick={(event) => { event.stopPropagation();toggleSelectedSubjects("ela")}} className={isElaSelected ? 'opened-caret highlighted-caret' : 'caret-icon-container'}><ArrowSVG /></div>}
      </div>
      {selectedSubjects.includes("ela") ? renderTopics(treeData?.[0], 0) : null}
    </>)
  }

  const renderTeacherDashboardTopics = (isRoot = false) => {
    let subjectCode = getCurrentSelectedSubjectCode();
    return (<>
      {renderTopics(treeData?.[subjectCode], subjectCode, isRoot)}
    </>)
  }

  const getCount = () => {
    if (lastNode) {
      return `(${lastNode.item.playable_count})`;
    } else if (mobileList3){
      return  `(${mobileList3.item.playable_count})`;
    } else if (mobileList2) {
      return `(${mobileList2.item.playable_count})`;
    }
  }

  const shouldShowResetButton = () => {
    if (visibleNodes.length) {
      if (lastNode && lastNode.data?.id !== visibleNodes[visibleNodes.length - 1]) {
        return true;
      } else if (!lastNode && mobileList3 && mobileList3.data?.id !== visibleNodes[visibleNodes.length - 1]) {
        return true;
      } else if (!lastNode && !mobileList3 && mobileList2 && mobileList2.data?.id !== visibleNodes[visibleNodes.length - 1]) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }

  const getCurrentSelectedSubjectCode = () => {
    return subjectCode === "ela" ? 0 : 1
  }

  const getSubjectCodeOfFirstBreadcrumb = () => {
    return activeBreadcrumb?.[0]?.title === "Math" ? 1 : 0;
  }

  const renderMobileView = () => {
    return (<>
    <div className='levels-container'>
      {renderMobileTopics(treeData?.[getCurrentSelectedSubjectCode()], getCurrentSelectedSubjectCode(), 0)}
      {mobileList2?.item?.children?.length > 0 ? renderMobileTopics(mobileList2?.item, getCurrentSelectedSubjectCode(), 1) : null}
      {mobileList3?.item?.children?.length > 0 ? renderMobileTopics(mobileList3?.item, getCurrentSelectedSubjectCode(), 2) : null}
    </div>
      <div className='levels-cta-container'>
        {shouldShowResetButton() ?
          <Button
            type={ButtonTypes.primary}
            onClick={() => { 
              setMobileList2(null);
              setMobileList3(null);
              setLastNode(null);
              setVisibleNodes([]);
            }}
          >
            Reset filters
          </Button> : null
        }
        {mobileList2 ?
        <Button
          type={ButtonTypes.secondary}
          className='custom-apply-btn'
          onClick={() => {
            [mobileList2, mobileList3].forEach(listItem => {
              topicClicked(listItem.item);
            })
            setShowHeader(false);
          }}
        >
          {`View ${getCount()} printables`}
          &nbsp;<RightArrowSVG />
        </Button> : null }
      </div>
    </>)
  }

  const shouldShowBorder = (item: ITreeItem) => {
    if (lastNode && lastNode?.item?.id  === item?.id) {
      return 'selected';
    } 
    else if (!lastNode && mobileList3 && mobileList3?.item?.id  === item?.id) {
      return 'selected';
    } else if (!lastNode && !mobileList3 && mobileList2 && mobileList2?.item?.id  === item?.id) {
      return 'selected';
    } else {
    return ''
    }
  }

  const renderMobileTopics = (data: ITreeItem, itemType: number, level: number) => {
    return <div className={`mobile-list level${level}`}>
    
    {data?.children?.map((item: ITreeItem) => <div key={item?.id} className={`worksheet-topic-container worksheet-topic-container__mobile ${shouldShowBorder(item)}`}>
      <div onClick={() => {
        if (level === 0) {
          setMobileList2({data, item})
          setMobileList3(null)
          setLastNode(null)
        } else if (level === 1) {
          setMobileList3({data, item})
          setLastNode(null)
        } else if (level === 2) {
          setLastNode({data, item})
        } 

        }} className={`worksheet-topic-name ${visibleNodes[visibleNodes.length - 1] === item?.id ? 'selected' : ''}`}>
        <div className='worksheet-label'>
          {item.title}
        </div>
        {item?.children?.length > 0 ? <ArrowSVG /> : null}
      </div>
    </div>
    )}
    </div>
  }


  return (
    <div className='topic-selector'>
      <span className='heading'>{isMobile ? `${subjectCode === "ela" ? "Reading Topics" : "Math Topics"}`: worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? "TOPICS" : "Printable Topic"}</span>
      {isMobile ? renderMobileView() : renderDesktopTopics()}
    </div>
  )
}

export default WorksheetTopicSelector